import React from 'react';

import { Card, Skeleton, Stack, Text } from '@mantine/core';

import DistributionOfHeavyCdr3LengthsPlot from './DistributionOfHeavyCdr3LengthsPlot';
import { LoadingContainer } from '../common/LoadingContainer';
import type { BinnedData } from '../generated/generatedOpenAPI';

interface HeavyChainCdr3DistributionsProps {
  cdr3LengthDistributionData: BinnedData | null | undefined;
  isLoading?: boolean;
}

export default function HeavyChainCdr3Distributions({ cdr3LengthDistributionData, isLoading }: HeavyChainCdr3DistributionsProps) {
  if (isLoading) {
    return (
      <Card withBorder>
        <LoadingContainer height={300} />
      </Card>
    );
  }

  if (!cdr3LengthDistributionData) {
    return (
      <Card withBorder>
        <Skeleton height={300} />
      </Card>
    );
  }

  return (
    <Card withBorder>
      <Stack gap="xl">
        <Text>Heavy Chain CDR3 Distributions Data</Text>
        <DistributionOfHeavyCdr3LengthsPlot cdr3LengthDistributionData={cdr3LengthDistributionData} />
      </Stack>
    </Card>
  );
}
